"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const use_context_selector_1 = require("use-context-selector");
const context_1 = require("../context");
const interfaces_1 = require("../interfaces");
const Row = React.forwardRef((_a, ref) => {
    var { className, spacing: spacingProp } = _a, rest = tslib_1.__rest(_a, ["className", "spacing"]);
    const spacingContext = (0, use_context_selector_1.useContextSelector)(context_1.GridContext, context => context.spacing);
    const config = React.useMemo(() => {
        var _a;
        return interfaces_1.ContainerSizes[(_a = spacingProp !== null && spacingProp !== void 0 ? spacingProp : spacingContext) !== null && _a !== void 0 ? _a : 'cozy'];
    }, [spacingContext, spacingProp]);
    return (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({}, rest, { container: true, ref: ref, className: className, spacing: config }));
});
exports.default = React.memo(Row);
